var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamp2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 149,
    viewBox: "0 0 86 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4639_123221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5575 125.74C42.3475 125.74 42.1875 125.57 42.1875 125.36V0.38C42.1875 0.17 42.3575 0 42.5575 0C42.7575 0 42.9275 0.17 42.9275 0.38V125.37C42.9275 125.58 42.7575 125.75 42.5575 125.75V125.74Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2306 143.26C51.2306 145.89 47.3506 148.03 42.5606 148.03C37.7706 148.03 33.8906 145.89 33.8906 143.26C33.8906 140.63 37.7706 138.49 42.5606 138.49C47.3506 138.49 51.2306 140.63 51.2306 143.26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81 132.63C51.35 128.55 45.43 125.45 42.55 120.89C39.68 125.45 33.75 128.55 18.29 132.63C2.28 136.86 0.04 143.24 0 143.26H42.56H85.12C85.08 143.24 82.84 136.86 66.82 132.63H66.81Z",
    fill: "#F09400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4639_123221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.11,
    height: 148.03,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp2);
export default __webpack_public_path__ + "static/media/lamp-2.3a88bc1fcc7ad109afa43a0d908eced0.svg";
export { ForwardRef as ReactComponent };